module.exports = __webpack_public_path__ + "static/img/mouse.322514e3.png";